import { ChevronUp, ChevronDown } from "lucide-react";

const ChevronTableHeader = ({...props}) => {
  return props?.ascending ? <ChevronUp className="h-5 w-5" /> : <ChevronDown className="h-5 w-5" />;
};

export default ChevronTableHeader;
